// Parcel inlines process.env at build time — CLERK_PUBLISHABLE_KEY is safe here (client-side key)
const PUBLISHABLE_KEY = process.env.CLERK_PUBLISHABLE_KEY || '';

// Clerk is loaded from CDN (script tag in index.html) to avoid Parcel failing on
// dynamic imports for UI components. The CDN bundle includes all UI out of the box.
let clerk: any;

// Derive Clerk FAPI hostname from the publishable key (pk_test_<base64(domain$)>)
function clerkFapiHost(): string {
    const encoded = PUBLISHABLE_KEY.replace(/^pk_(test|live)_/, '');
    return atob(encoded).replace(/\$$/, '');
}

function loadClerkScript(): Promise<void> {
    return new Promise((resolve, reject) => {
        const host = clerkFapiHost();
        const script = document.createElement('script');
        script.src = `https://${host}/npm/@clerk/clerk-js@5/dist/clerk.browser.js`;
        script.crossOrigin = 'anonymous';
        script.dataset.clerkPublishableKey = PUBLISHABLE_KEY;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Clerk SDK from CDN'));
        document.head.appendChild(script);
    });
}

export async function initClerkAuth(): Promise<void> {
    if (!PUBLISHABLE_KEY) {
        console.warn('[hotplate] No CLERK_PUBLISHABLE_KEY — running without authentication.');
        return;
    }
    await loadClerkScript();
    clerk = (window as any).Clerk;
    if (!clerk) {
        throw new Error('Clerk global not found after loading CDN script');
    }
    await clerk.load();
}

export function isSignedIn(): boolean {
    if (!PUBLISHABLE_KEY) return true;
    return !!clerk?.session;
}

export function redirectToSignIn(): void {
    clerk.redirectToSignIn({redirectUrl: window.location.href});
}

export function mountSignIn(element: HTMLDivElement): void {
    clerk.mountSignIn(element);
}

export function addListener(callback: (resources: any) => void): void {
    clerk.addListener(callback);
}

export async function getAuthToken(): Promise<string> {
    if (!clerk?.session) {
        return '';
    }
    const token = await clerk.session.getToken();
    if (!token) {
        throw new Error('Failed to retrieve auth token from Clerk session');
    }
    return token;
}

export function getUserDisplayName(): string {
    const user = clerk?.user;
    if (!user) return 'Chef';
    return user.firstName || user.username || user.primaryEmailAddress?.emailAddress || 'Chef';
}
